import Button from 'assets/components/button/Button';
import LinkButton from 'assets/components/button/LinkButton';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import Icon from 'assets/components/icon/Icon';
import { getLocales, Language } from 'assets/locales/Locale';
import Theme from 'assets/themes/Theme.Common';
import { preventDefaultBehavior } from 'assets/utils/dom/Events';
import { compact } from 'lodash';
import { useRef } from 'react';
import { SubfeeForm } from '../Subfee.Edit';

export default function SubfeeDocumentTranslation({
  document,
  languageIsoCode,
  index,
}: {
  document?: Utils.Unpacked<SubfeeForm['documents']>;
  languageIsoCode: Locale.Languages;
  index: number;
}) {
  const { lang } = getLocales();
  const fileInput = useRef<HTMLInputElement>();
  const { form } = useModalForm<SubfeeForm>();
  const foundDoc = document?.isDeleted ? null : document;
  const foundTranslation = compact(foundDoc?.translatedDocuments).find(
    (d) => d.languageIsoCode === languageIsoCode && !d.isDeleted
  );
  const docExists = languageIsoCode === Language.english ? !!foundDoc : !!foundTranslation;

  const alreadyUploadedDoc =
    languageIsoCode === Language.english
      ? foundDoc?.id
        ? foundDoc?.mediaFile
        : null
      : foundTranslation?.id
      ? foundTranslation?.mediaFile
      : null;

  function handleDelete() {
    if (form.data.documents && form.data.documents[index]) {
      form.data.documents[index].isDeleted = true;
      form.data.documents[index].translatedDocuments = compact(form.data.documents[index].translatedDocuments).map(
        (t) => (t.languageIsoCode === languageIsoCode ? { ...t, isDeleted: true } : t)
      );
    }
    form.update({ documents: [...form.data.documents] });
  }
  function handleDeleteTranslation() {
    if (form.data.documents && form.data.documents[index]) {
      form.data.documents[index].translatedDocuments = compact(form.data.documents[index].translatedDocuments).map(
        (t) => (t.languageIsoCode === languageIsoCode ? { ...t, isDeleted: true } : t)
      );
    }
    form.update({ documents: [...form.data.documents] });
  }

  function handleUpload(formFile?: File) {
    if (formFile) {
      form.update({
        documents: [
          ...form.data.documents,
          {
            mediaFile: formFile,
            translatedDocuments: [],
          },
        ],
      });
    }
  }

  function handleUploadTranslation(formFile?: File) {
    if (form.data.documents && form.data.documents[index]) {
      form.data.documents[index].translatedDocuments = compact(form.data.documents[index].translatedDocuments).map(
        (t) => (t.languageIsoCode === languageIsoCode ? { ...t, isDeleted: true } : t)
      );
      form.data.documents[index].translatedDocuments.push({
        documentType: 'MediaFileSubfee',
        languageIsoCode,
        formFile,
      });
    }
    form.update({ documents: [...form.data.documents] });
  }

  return (
    <>
      {docExists ? (
        <Button
          class={ThemeButtonCircle}
          media={<Icon class="fas-trash" />}
          style={{ display: 'inline-flex', color: Theme.Color.error }}
          onClick={() => {
            if (languageIsoCode === Language.english) {
              handleDelete();
            } else if (foundDoc) {
              handleDeleteTranslation();
            }
          }}
          htmlElementProps={{
            title: lang.delete,
          }}
        />
      ) : (
        <>
          <input
            ref={fileInput}
            onClick={(event) => event.stopPropagation()}
            onChange={(event) => {
              preventDefaultBehavior(event);
              if (languageIsoCode === Language.english) {
                handleUpload(event.currentTarget.files[0]);
              } else if (foundDoc) {
                handleUploadTranslation(event.currentTarget.files[0]);
              }
              event.currentTarget.value = '';
            }}
            type="file"
            accept="*"
            multiple={false}
            style={{ display: 'none' }}
          />
          <Button
            class={ThemeButtonCircle}
            style={{ display: 'inline-flex', color: Theme.Color.success }}
            media={<Icon class="fas-upload" />}
            disabled={languageIsoCode == Language.english ? false : !foundDoc}
            onClick={() => fileInput?.current.click()}
            htmlElementProps={{
              title: lang.upload,
            }}
          />
        </>
      )}
      <LinkButton
        media={<Icon class="fas-download" />}
        style={{ display: 'inline-flex' }}
        class={ThemeButtonCircle}
        disabled={!alreadyUploadedDoc}
        htmlElementProps={{
          title: `${lang.download} - ${alreadyUploadedDoc?.name}`,
        }}
        url={alreadyUploadedDoc?.url}
      />
    </>
  );
}
